import { cn } from "@/lib/utils"
import { useSidebar } from "./sidebar-context"

export function Sidebar({ 
  children,
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  const { isCollapsed } = useSidebar()

  return (
    <div
      className={cn(
        "group fixed left-0 top-0 z-40 flex h-screen flex-col border-r bg-white transition-all duration-300 ease-in-out",
        isCollapsed ? "w-[60px] hover:w-64" : "w-64",
        className
      )}
      {...props}
    >
      {children}
    </div>
  )
}

export function SidebarHeader({ 
  children,
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("flex h-14 items-center border-b px-3", className)}
      {...props}
    >
      {children}
    </div>
  )
}

export function SidebarContent({ 
  children,
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("flex-1 overflow-auto p-3", className)}
      {...props}
    >
      {children}
    </div>
  )
}

export function SidebarFooter({ 
  children,
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("border-t p-3", className)}
      {...props}
    >
      {children}
    </div>
  )
}